import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DBAgentTaskRequestResponse } from '~/protos/agents'
import { initialConversationUUID } from './utils'

type SliceState = {
  task_objs: Record<string, TaskObject | null>
}

function buildInitialState(): SliceState {
  const uuid = initialConversationUUID()
  return {
    task_objs: { [uuid]: null }
  }
}

const initialState: SliceState = buildInitialState()

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setTaskObj(state, action: PayloadAction<{ task: TaskObject | null; uuid: string }>) {
      const { task = null, uuid } = action.payload
      if (task == null) {
        state.task_objs[uuid] = task
        return
      }
      const { details, ...rest } = task
      const taskObj = Object.assign(rest, { details: DBAgentTaskRequestResponse.fromJSON(details) })
      state.task_objs[uuid] = taskObj
    }
  }
})

export const { setTaskObj } = chatSlice.actions

export default chatSlice.reducer
